export function groupApprovalLevelsFromApi(data) {
    const byLevel = {};
    (Array.isArray(data) ? data : []).forEach((row) => {
        const level = Number(row.level);
        if (!byLevel[level]) {
            byLevel[level] = { level, approverIds: [] };
        }
        const ids = Array.isArray(row.approverIds)
            ? row.approverIds
            : [row.approverId != null ? row.approverId : row.approver_id];
        ids.forEach((id) => {
            if (id == null || id === '') return;
            const value = String(id);
            if (!byLevel[level].approverIds.includes(value)) {
                byLevel[level].approverIds.push(value);
            }
        });
    });
    return Object.values(byLevel).sort((a, b) => a.level - b.level);
}

export function serializeApprovalLevelsForApi(levels) {
    return (levels || []).map((level) => ({
        level: level.level,
        approverIds: (level.approverIds || [])
            .map((id) => parseInt(id, 10))
            .filter((id) => !Number.isNaN(id)),
    }));
}

export function emptyApprovalLevel(level = 1) {
    return { level, approverIds: [] };
}
